<template>
  <div class="admin">
    <nav-bar/>
    <Title content="管理员界面"/>
    <img src="~assets/img/admin/background.jpg" alt="" style="width: 100%; height: 50vh;">

    <!--新增科研信息-->
    <div class="title" :class="{isLetterSpace: showLang === 'zh'}">{{$t('admin.信息管理')}}</div>
    <!--导航上-->
    <SecNav :menu="menu" @menuClick="menuClick"/>


    <router-view/>

    <Footer/>

  </div>

</template>

<script>
  import NavBar from "@/components/common/NavBar";
  import Title from "@/components/common/Title";
  import SecNav from "@/components/common/SecNav";
  import NewResearch from "./Subpages/ResearchSubpages/NewResearch";
  import NewPapers from "./Subpages/ResearchSubpages/NewPapers";
  import Footer from "@/components/common/Footer";
  import Remind from "@/components/common/Remind";

  import { mapGetters } from 'vuex'

  import { ref, reactive } from 'vue'
  import { useRouter } from 'vue-router'

  export default {
    name: "Index",
    components:{
      Footer,
      NavBar,
      Title,
      SecNav,
      NewResearch,
      NewPapers,
      Remind,
    },
    computed:{
      ...mapGetters(['showLang']),
    },
    setup(){

      const router = useRouter();
      //navSec
      let menu = reactive([
        {name:'科学研究', router: '/admin/researchIndex/newResearch'},
        {name:'组内动态', router: '/admin/NewGroupDynamics'},
        {name:'合作信息', router: '/admin/newCooperation'},
        {name:'组织架构', router: '/admin/NewStructure'},
        {name:'在线服务', router: '/admin/newService'},
        {name:'注册登录', router: '/admin/LoginInfo'},
      ]);
      //
      let currentMenu = ref('科学研究');



      //methods
      // 页面刷新即跳转到'index'页
      window.onload = function () {
        router.push('/admin/researchIndex/newResearch')
      };

      function menuClick(menuName, addr) {
        currentMenu.value = menuName;
        router.push(addr)
      }

      return{ menu, currentMenu, menuClick }
    },//setup
  }
</script>

<style scoped lang="less">
  .admin{
    .title{
      font-size: 30px;
      color: #333333;
      line-height: 50px;
      text-align: center;
      padding: 40px 0 25px 0;
      //letter-spacing: 5px;
    }

    .isLetterSpace { letter-spacing: 5px; }

  }
</style>